import React, { useState } from "react"
import { useParams, Link, useNavigate } from "react-router-dom"
import AuthLayout from "../components/AuthLayout"
import PasswordVisibilityToggle from "../components/PasswordVisibilityToggle"
import { getAPIBaseURL } from "../services/helpers"
import { postData } from "../services/request"
import { validatePassword } from "../services/validators"

const ResetPassword = () => {
  const { userId, token } = useParams()
  const navigate = useNavigate()
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [btnState, setBtnState] = useState("Reset password")
  const [error, setError] = useState([
    { field: "password", msg: "" },
    { field: "confirmPassword", msg: "" }
  ])
  const [genError, setGenError] = useState("")
  const [genMsg, setGenMsg] = useState("")

  const validateForm = () => {
    let ok = true
    const errs = [...error]
    const pVal = validatePassword(password)
    errs[0].msg = pVal.result
    if (pVal.error != "") ok = false
    if (password !== confirmPassword){
      errs[1].msg = "Passwords do not match"
      ok = false
    }else{
      errs[1].msg = ""
    }
    setError(errs)
    return ok
  }

  const submit = async () => {
    setGenError("")
    setGenMsg("")
    if (!validateForm()) return
    setBtnState("Submitting...")
    const url = `${getAPIBaseURL()}/employme/auth/password-reset/${userId}/${token}`
    const headers = { 'Content-Type': 'application/json' }
    const payload = { newPassword: password }
    const res = await postData(url, headers, payload)
    setBtnState("Reset password")
    if (res.error == ""){
      if(res.result.status === 200){
        setGenMsg(res.result.data?.data?.message || 'Password reset successful')
        setTimeout(() => navigate('/login'), 1500)
      }else{
        const errData = res.result.data?.data
        setGenError(typeof errData === 'string' ? errData : (errData?.message || 'Password reset failed'))
      }
    }else{
      const errData = res.result?.data?.data
      setGenError(typeof errData === 'string' ? errData : (errData?.message || 'Network error'))
    }
  }

  return (
    <AuthLayout title="Reset password" subtitle="Enter a new secure password to access your account.">
      <div className="space-y-5">
        {genMsg ? <div className="rounded-lg bg-green-50 p-3 text-sm font-semibold text-green-600">{genMsg}</div> : null}
        {genError ? <div className="rounded-lg bg-red-50 p-3 text-sm font-semibold text-red-500">{genError}</div> : null}

        <div>
          <label htmlFor="password" className="mb-2 block text-sm font-medium text-gray-900">New password</label>
          <div className="relative">
            <input
              value={password}
              onChange={(e)=>setPassword(e.target.value)}
              type={showPassword ? "text" : "password"}
              id="password"
              className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 pr-10 text-sm text-gray-900 focus:border-primary-600 focus:ring-primary-600"
              placeholder="••••••••"
            />
            <PasswordVisibilityToggle
              visible={showPassword}
              onToggle={() => setShowPassword((prev) => !prev)}
            />
          </div>
          {error[0].msg ? <p className="mt-1 text-sm font-semibold text-red-500">{error[0].msg}</p> : null}
        </div>

        <div>
          <label htmlFor="confirmPassword" className="mb-2 block text-sm font-medium text-gray-900">Confirm password</label>
          <div className="relative">
            <input
              value={confirmPassword}
              onChange={(e)=>setConfirmPassword(e.target.value)}
              type={showConfirmPassword ? "text" : "password"}
              id="confirmPassword"
              className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 pr-10 text-sm text-gray-900 focus:border-primary-600 focus:ring-primary-600"
              placeholder="••••••••"
            />
            <PasswordVisibilityToggle
              visible={showConfirmPassword}
              onToggle={() => setShowConfirmPassword((prev) => !prev)}
            />
          </div>
          {error[1].msg ? <p className="mt-1 text-sm font-semibold text-red-500">{error[1].msg}</p> : null}
        </div>

        <button onClick={()=>submit()} type="button" className="w-full rounded-lg bg-black px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300">{btnState}</button>
        <p className="text-sm font-light text-gray-500"><Link to="/login" className="font-medium text-blue-600 hover:underline">Back to login</Link></p>
      </div>
    </AuthLayout>
  )
}

export default ResetPassword


